export class Reference {
	referenceBasketVersion: string;

	constructor(referenceBasketVersion: string) {
		this.referenceBasketVersion = referenceBasketVersion;
	}
}
